<template>
  <div>
    <BaseModal :config="docModalConfig">
      <BaseDocumentMgrandDropoff
        ref="InitialIssuanceDocumentMgr"
        :mgrGridQuery="filterCondition"
        :transactionRecord="transactionRecord"
      ></BaseDocumentMgrandDropoff>
    </BaseModal>
  </div>
</template>

<script>
import BaseDocumentMgrandDropoff from "@/components/base/BaseDocumentMgrandDropoff.vue";
import BaseModal from "@/components/base/BaseModal.vue";

export default {
  name: "InitialIssuanceDocumentDropoffForm",
  props: {
    docModalConfig: {},
    filterCondition: {},
    transactionRecord:{}
  },
  components: {
    BaseModal,
    BaseDocumentMgrandDropoff
  },
  data: function() {
    return {
      businessEvent: "Issuance",
      auditFileType: "Initial Issuance"
    };
  },
  methods: {},
  mounted() {},
  created() {

   
  }
};
</script>
